// // src/components/homepage/RentCube.jsx
// import React from "react";
// import { motion } from "framer-motion"; // ✅ Import framer-motion
// import settlements from "../../assets/images/settlements.png";

// const Settlements = () => {
//   return (
//     <div className="mx-auto lg:container">
//       <motion.div
//         initial={{ opacity: 0, y: 50 }} // Start faded + shifted down
//         whileInView={{ opacity: 1, y: 0 }} // Animate into view
//         transition={{ duration: 0.8, ease: "easeOut" }} // Smooth animation
//         viewport={{ once: true }} // Animate only once
//         className="bg-agBg my-8 rounded-xl container mx-4"
//       >
//         <div className="mx-auto flex flex-col md:flex-row items-center gap-10 py-12 px-2 md:px-4 lg:px-12">
//           {/* Text Section */}
//           <div className="flex-1 text-left md:text-left">
//             <p className="text-agPrimary text-xl mb-2 md:mb-4">
//               GET PAID SEAMLESSLY
//             </p>
//             <div className="text-agPrimary uppercase font-semibold text-xs mb-2 bg-[#D6F2E1] py-1 px-4 rounded-md w-24 mb-8 md:mb-16 lg:mb-24">
//               VENDORS
//             </div>
//             <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-2">
//               Settlements directly to <br />
//               your Bank Account
//             </h2>
//             <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
//               Track your earnings and payouts in real time. Withdraw easily to
//               your linked bank account — no stress, no delays.
//             </p>

//             <a
//               href="https://vendor.agrolinka.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="bg-agGreen text-agBlue py-3 rounded-full text-sm md:text-lg font-medium transition"
//             >
//               Get Started →
//             </a>
//           </div>

//           {/* Image Section */}
//           <motion.div
//             initial={{ scale: 0.8, opacity: 0 }}
//             whileInView={{ scale: 1, opacity: 1 }}
//             transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//             viewport={{ once: true }}
//             className="hidden md:block md:flex-1 md:flex md:justify-center"
//           >
//             <img
//               src={settlements}
//               alt="Cubes"
//               className="w-full max-w-md md:max-w-lg"
//             />
//           </motion.div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default Settlements;

// src/components/homepage/RentCube.jsx
import React from "react";
import { motion } from "framer-motion"; // ✅ Import framer-motion
import settlements from "../../assets/images/settlements.png";

const Settlements = () => {
  return (
    <div className="mx-2 lg:container">
      <motion.div
        initial={{ opacity: 0, y: 50 }} // Start faded + shifted down
        whileInView={{ opacity: 1, y: 0 }} // Animate into view
        transition={{ duration: 0.8, ease: "easeOut" }} // Smooth animation
        viewport={{ once: true }} // Animate only once
        className="bg-agBg mt-0 rounded-xl container"
      >
        <div className="mx-auto flex flex-col md:flex-row items-center gap-10 py-12 px-2 md:px-4 lg:px-12">
          {/* Text Section */}
          <div className="flex-1 text-left md:text-left">
            <p className="text-agPrimary text-xl mb-2 md:mb-4">
              GET PAID SEAMLESSLY
            </p>
            <div className="text-agPrimary uppercase font-semibold text-xs mb-2 bg-[#D6F2E1] py-1 px-4 rounded-md w-24 mb-8 md:mb-16 lg:mb-24">
              VENDORS
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-2">
              Settlements directly <br />
              to your Bank Account
            </h2>
            <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
              Track your earnings and payouts in real time. Withdraw easily to
              your linked bank account — no stress, no delays.{" "}
            </p>

            <a
              href="https://vendor.agrolinka.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-agGreen text-agBlue py-3 rounded-full text-sm md:text-lg font-medium transition"
            >
              Get Started →
            </a>
          </div>

          {/* Image Section */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
            className="hidden md:block md:flex-1 md:flex md:justify-center"
          >
            <img
              src={settlements}
              alt="Cubes"
              className="w-full max-w-md md:max-w-lg"
            />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Settlements;
